var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralCertificationInfo = function SvgGeneralCertificationInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillRule: "evenodd",
    d: "M12 22.5C6.21 22.5 1.5 17.79 1.5 12S6.21 1.5 12 1.5 22.5 6.21 22.5 12 17.79 22.5 12 22.5",
    clipRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.357 17.009h1.286v-6.388h-1.286zm-.037-8.648h1.36V7h-1.36z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.357 17.009h-.25v.25h.25zm1.286 0v.25h.25v-.25zm0-6.388h.25v-.25h-.25zm-1.286 0v-.25h-.25v.25zm-.037-2.26h-.25v.25h.25zm1.36 0v.25h.25v-.25zm0-1.361h.25v-.25h-.25zm-1.36 0v-.25h-.25V7zm.037 10.259h1.286v-.5h-1.286zm1.536-.25v-6.388h-.5v6.388zm-.25-6.638h-1.286v.5h1.286zm-1.536.25v6.388h.5v-6.388zm.213-2.01h1.36v-.5h-1.36zm1.61-.25V7h-.5v1.36zm-.25-1.611h-1.36v.5h1.36zM11.07 7v1.36h.5V7z"
  }))));
};
export default SvgGeneralCertificationInfo;